
let intervalId;

function closeActiveMenu() {
  $('.parent-link > a.active').each((_, el) => {
    $(el).removeClass('active');
    $(el).closest('.parent-link').find('.child-menu').fadeOut(500);
    $(el).closest('.parent-link').find('.menu-toggle').removeClass('active');
  });
}

$(document).ready(() => {

  $('#mobileMenuContainer .menu-toggle').click(function() {
    window.scrollTo(0, 0);
    $(this).next().slideToggle(500);
    $(this).toggleClass('active');
    $(this).closest('.parent-link').find('.menu-link').toggleClass('active');
  });

  $('#mobileMenuContainer a:not([href="#"])').click(function() {
    $('#mobileMenuToggle').click()
  });

  $('body').click(function (e) {
    if ($(e.target).closest('.parent-link').length === 0) {
      closeActiveMenu();
    }
  })

  $('.parent-link > a').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    const isActive = $(this).hasClass('active');
    closeActiveMenu();

    if (!isActive) {
      $(this).addClass('active');
      $(this).closest('.parent-link').find('.child-menu').fadeIn(500);
      $(this).closest('.parent-link').find('.menu-toggle').addClass('active');
    }
  });

  $('.announcement__close').click(function (e) {
    $('.announcement').hide();
    localStorage.setItem('hide_announcement', '1');
  })

  const hideAnnouncement = localStorage.getItem('hide_announcement');
  if (hideAnnouncement !== '1') {
    $('.announcement').show();
  }

  let lastScrollTop = 0;
  $(window).on('scroll', function () {

    //if the page is the capsule editor, dont do nuthin here, leave as is
    if ($('html').hasClass('no-animate-header')) return;
    
    const st = $(this).scrollTop();
    const header = $('#shopify-section-cad-header, #shopify-section-header-2026');
    const page_container = $('body');

    const BaSNewDiscountProgress = $('.page-build_a_system_new .discount-progress-wrapper')?.parent()
    const BaSNewPreviewContainer = $('.stickyContainer', '.page-build_a_system_new ')
    const headerHeight = header.height();
    header.css('top', -headerHeight);


    if (st > lastScrollTop){
      header.removeClass('fixed');
      page_container.removeClass('navigation-shown');
      if (isDesktop()) {
        BaSNewDiscountProgress?.css('top', 0);
        BaSNewPreviewContainer?.css('top', BaSNewDiscountProgress.height());
      }

    } else {
      header.addClass('fixed');
      page_container.addClass('navigation-shown');
      if (isDesktop()) {
        BaSNewDiscountProgress?.css('top', headerHeight);
        BaSNewPreviewContainer?.css('top', BaSNewDiscountProgress.height() + headerHeight);
      }

    }

    lastScrollTop = st;
  })

  const announcements = $('.announcement__wrapper');
  const announcementBar = $('.announcement');
  const animationTimeout = parseFloat(announcementBar.data('animation-timeout'));
  if (!announcements.length) return;

  const initialAnnouncement = $(announcements[0]);

  function setActiveAnnouncement($item) {
    announcements.removeClass('active').attr('aria-hidden', 'true');
    $item.addClass('active').attr('aria-hidden', 'false');
  }

  setActiveAnnouncement(initialAnnouncement);

  if (announcements.length < 2) return;

  function resetAnnouncementInterval() {
    clearInterval(intervalId);
    intervalId = setInterval(animateAnnouncement, animationTimeout);
  }

  function animateAnnouncement() {
    const currentActiveItem = $('.announcement__wrapper.active');
    const nextSibling = currentActiveItem.next('.announcement__wrapper');
    const nextActiveItem = nextSibling.length > 0 ? nextSibling : initialAnnouncement;
    setActiveAnnouncement(nextActiveItem);
    // TODO: now we need to update this to show the announcements or skip the announcements that don't apply to them if they have specific (or they dont have them...) utm parameters in their session
  }

  function showNextAnnouncement() {
    resetAnnouncementInterval();
    const currentActiveItem = $('.announcement__wrapper.active');
    const nextSibling = currentActiveItem.next('.announcement__wrapper');
    const nextActiveItem = nextSibling.length > 0 ? nextSibling : initialAnnouncement;
    setActiveAnnouncement(nextActiveItem);
  }

  function showPreviousAnnouncement() {
    resetAnnouncementInterval();
    const currentActiveItem = $('.announcement__wrapper.active');
    const lastAnnouncement = $(announcements[announcements.length - 1]);
    const prevSibling = currentActiveItem.prev('.announcement__wrapper');
    const nextActiveItem = prevSibling.length > 0 ? prevSibling : lastAnnouncement;
    setActiveAnnouncement(nextActiveItem);
  }

  intervalId = setInterval(animateAnnouncement, animationTimeout);

  announcementBar.on('click', '.new_announcement__arrow-left', showPreviousAnnouncement);
  announcementBar.on('click', '.new_announcement__arrow-right', showNextAnnouncement);

  announcementBar.on('keydown', function (e) {
    const $target = $(e.target);
    if ($target.closest('.announcement__link, a').length) return;
    if (!$target.is(announcementBar) && !$target.closest('.new_announcement__arrow-left, .new_announcement__arrow-right').length) return;
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      showPreviousAnnouncement();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      showNextAnnouncement();
    }
  });
});
